import { ReviewDetailPage } from './ReviewDetailPage';
export default ReviewDetailPage;
